import { Suspense } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import AppRoutes from '@/routes';
import Spinner from '@/components/Spinner';
import GlobalErrorToast from '@/shared/ui/GlobalErrorToast';
import { google } from '@/config/env';

function App() {
  if (import.meta.env.DEV && !google.clientId) {
    console.warn(
      '[App] ⚠️ VITE_GOOGLE_CLIENT_ID is not set. Google Meet integration will not work.\n' +
        'Get a Client ID from: https://console.cloud.google.com/apis/credentials\n' +
        'Then add it to .env.local: VITE_GOOGLE_CLIENT_ID=your-id.apps.googleusercontent.com',
    );
  }

  return (
    <GoogleOAuthProvider clientId={google.clientId}>
      <Suspense fallback={<Spinner fullScreen />}>
        <AppRoutes />
      </Suspense>
      <GlobalErrorToast />
    </GoogleOAuthProvider>
  );
}

export default App;
